'use client'
import { faClockRotateLeft, faCreditCard } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "@/lib/style";
import Details from "@/lib/programContent";

type Props = {
  programName: string;
};

export default function GeneralLearn(props: Props) {
  const { programName } = props;
  const matchedStyle = Style.find(style => style.title === programName);
  const detail = Details[programName].learn;

  return (
    <section className={`mb-24 ${matchedStyle?.colors?.[0].colorSection} bg-opacity-5`}>
      <div className="flex flex-col md:flex-row justify-center text-center mx-auto py-2 bigscreen-responsive md:justify-around md:text-left xl:mt-44 md:px-0">
        <div>
          <div className="flex md:flex-col gap-8 px-8 items-center text-left py-8 xl:text-left xl:px-0 xl:gap-4 xl:gap-y-8 xl:-mx-24 h-full justify-around">
            <div>
              <div className={`${matchedStyle?.colors?.[0].textColor} flex items-center gap-3 uppercase text-xs font-bold md:text-lg xl:justify-start xl:gap-6`}>
                <FontAwesomeIcon icon={faClockRotateLeft} className="text-md md:text-2xl" />
                <span>Horarios</span>
              </div>
              <div className="px-0 py-2 max-w-xs font-thin text-xs md:text-sm xl:text-left xl:px-12">
                <p>Opciones entre semana en jornada diurna y nocturna, además opciones sabatinas.</p>
              </div>
            </div>
            <div>
              <div className={`${matchedStyle?.colors?.[0].textColor} flex items-center gap-3 uppercase text-xs font-bold md:text-lg xl:justify-start xl:gap-6`}>
                <FontAwesomeIcon icon={faCreditCard} className="text-md md:text-2xl" />
                <span>Formas de pago</span>
              </div>
              <div className="px-0 py-3 max-w-xs font-thin text-xs md:text-sm xl:text-left xl:px-12">
                <p>Ofrecemos múltiples formas de pago para que comencés a hacer realidad tu sueño</p>
              </div>
            </div>
          </div>
        </div>
        <div className="sm:flex sm:flex-col justify-center items-center md:block">
          <div className="text-lg max-w-md px-8 mt-8 md:px-2 md:text-2xl md:max-w-3xl xl:max-w-lg xl:px-0 xl:py-0 xl:-mx-24" dangerouslySetInnerHTML={{ __html: detail.title(matchedStyle?.colors?.[0].textColor + ' font-bold') }} />
          <div className="font-thin max-w-sm text-xs py-4 px-8 md:px-2 md:text-lg md:max-w-3xl xl:max-w-xl xl:px-0 xl:py-4 xl:-mx-24" dangerouslySetInnerHTML={{ __html: detail.firstParagraph }} />
          <div className="font-thin max-w-sm text-xs py-4 px-8 md:px-2 md:text-lg md:max-w-3xl xl:max-w-xl xl:px-0 xl:py-4 xl:-mx-24" dangerouslySetInnerHTML={{ __html: detail.secondParagraph }} />
        </div>
      </div>
    </section>
  );
}